<script setup lang="ts">
import { mdiMinus, mdiPlus } from '@mdi/js'
import { MdiSvg } from '@ramp106/omrjs-core-ui'

interface JobWizardStepFeaturesTabsItemEmits {
  (e: 'mouseover', event: MouseEvent): void
  (e: 'change', isChecked: boolean): void
}

interface JobWizardStepFeaturesTabsItemProps {
  id: string
  label: string
  price?: number
  isSelected?: boolean
}

const emit = defineEmits<JobWizardStepFeaturesTabsItemEmits>()

defineProps<JobWizardStepFeaturesTabsItemProps>()

const onChange = (event: Event) => {
  const { checked: isChecked } = event.target as HTMLInputElement

  emit('change', isChecked)
}
</script>

<template>
  <label
    :id="id"
    class="group !flex cursor-pointer items-center justify-between p-4 text-sm leading-none font-bold text-black shadow-[0_12px_14px_-20px,rgba(51,61,64,0.4)] tablet:text-base"
    :class="isSelected ? 'bg-mint text-white' : 'bg-white hover:text-mint'"
    @mouseover="$emit('mouseover', $event)"
  >
    <input :value="id" class="hidden" type="checkbox" :checked="isSelected" @change="onChange" />

    {{ label }}

    <div class="flex items-center">
      <div
        v-if="!!price || price === 0"
        class="mr-3 text-sm leading-none font-normal text-grey-600"
        :class="isSelected ? 'text-white' : 'group-hover:text-mint'"
      >
        {{ `${price}€` }}
      </div>

      <div
        class="flex items-center justify-center before:absolute before:h-8 before:w-8 before:rounded-full before:tablet:h-10 before:tablet:w-10"
        :class="{ 'circle before:group-hover:bg-mint-100': !isSelected }"
      >
        <MdiSvg :path="isSelected ? mdiMinus : mdiPlus" />
      </div>
    </div>
  </label>
</template>

<style scoped>
@reference '@ramp106/omrjs-config-tailwind/styles/index.css';

.circle {
  @apply before:group-hover:animate-[circle_0.3s_ease-in-out_both];
}

@keyframes circle {
  0% {
    transform: scale(0.5);
  }

  100% {
    transform: scale(1);
  }
}
</style>
